/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal/index.js";
import Content from "./content.js";
import Footer from "./footer.js";
import { ReactComponent as SettingsIcon} from "../../../resources/images/settings-icon.svg";

/* Styles */
import styles from "./styles.js";

const TripCreditsSettingsModal = ({
  showModal,
  setShowModal,
  settingsPreferences,
  setSettingsPreferences,
  optionsResponse,
  tripCreditsOptionsText,
  showTripCreditsConfirmActionModal,
  handleConfirmModalOpen
}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [initialSettingsPreferences, setInitialSettingsPreferences] = useState(null)

  useEffect(() => {
    if (settingsPreferences) setInitialSettingsPreferences({...settingsPreferences})
  }, [showModal])

  const handleSaveModal = async () => {
    handleConfirmModalOpen('confirm')
  };

  const settingsLocked = settingsPreferences?.remainingTimeForTripCreditAssignment !== "0:00" && settingsPreferences?.tripCreditAssignmentTimeInterval !== "0"
  const sameSettingsSelected = initialSettingsPreferences?.currentTripCreditAutoAssignmentType === settingsPreferences?.currentTripCreditAutoAssignmentType

  return (
    <UCModal
      className={classes.tripCreditsSettingsModal}
      mainModalDivStyling={showTripCreditsConfirmActionModal ? classes.backdropModal : undefined}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<SettingsIcon />}
      modalTitle={<FormattedMessage id="tripCredits.settings.modal.title" />}
      modalDescription={<FormattedMessage id="tripCredits.settings.modal.description" />}
      modalContent={
        <Content
          settingsPreferences={settingsPreferences}
          setSettingsPreferences={setSettingsPreferences}
          settingsLocked={settingsLocked}
          optionsResponse={optionsResponse}
          tripCreditsOptionsText={tripCreditsOptionsText}
        />
      }
      modalFooter={
        <Footer
          setShowModal={setShowModal}
          handleSaveModal={handleSaveModal}
          settingsLocked={settingsLocked}
          handleConfirmModalOpen={handleConfirmModalOpen}
          sameSettingsSelected={sameSettingsSelected}
        />
      }
      dataTestId="tripcreditssettingsmodal"
    />
  );
};

export default TripCreditsSettingsModal;